<div class="product-wrapper">
    <div class="swiper-container">
        <div class="swiper-button-prev">
            <ion-icon name="chevron-back"></ion-icon>
        </div>
        <div class="swiper-button-next">
            <ion-icon name="chevron-forward"></ion-icon>
        </div>
        <swiper [config]="swiperConfig">
            <ng-template swiperSlide *ngFor="let gold of goldArray">
                <div class="slide">
                    <shop-product [productId]="gold[0]" [product]="gold[1]" [animation]="false" [playAnimation]="playAnimation"></shop-product>
                </div>
            </ng-template>
        </swiper>
    </div>
</div>